/**
 * api.js — Client HTTP per i web service Outreach.
 * Mirror di PwasClientAPI in client_api.dart.
 * Dipende da: env.js
 */
class OutreachAPI {

    constructor() {
        this.baseUrl   = ENV.baseUrl;
        this.authId    = ENV.authIdGuest;
        this.authToken = ENV.authTokenGuest;
    }

    _headers() {
        return {
            'Content-Type': 'application/json',
            'pwa-auth-id':    this.authId,
            'pwa-auth-token': this.authToken,
        };
    }

    _replaceParams(action, params) {
        return action.replace(/\{(\w+)\}/g, (_, k) => (params[k] !== undefined ? params[k] : k));
    }

    async request(method, action, params = {}, data = {}) {
        const url  = this.baseUrl + this._replaceParams(action, params);
        const opts = { method: method.toUpperCase(), headers: this._headers() };
        if (method !== 'get' && method !== 'head') {
            opts.body = JSON.stringify(data);
        }
        try {
            const res = await fetch(url, opts);
            return await res.json();
        } catch (err) {
            console.error('[OutreachAPI] request error:', err);
            return { error: 'catch' };
        }
    }

    // POST /api/exec/{name}/{params}
    execItem(name, data, params = 'cron:1') {
        return this.request('post', '/api/exec/{name}/{params}', { name, params }, data);
    }

    // GET /api/list/{entity}/{page}/{params}
    listItem(entity, page = '1', params = 'void:1') {
        return this.request('get', '/api/list/{entity}/{page}/{params}', { entity, page, params });
    }

    // GET /api/get/{entity}/{id}/{params}
    getItem(entity, id, params = 'void:1') {
        return this.request('get', '/api/get/{entity}/{id}/{params}', { entity, id, params });
    }

    // POST /api/post/{entity}
    addItem(entity, data) {
        return this.request('post', '/api/post/{entity}', { entity }, data);
    }

    // POST /api/put/{entity}/{id}
    updItem(entity, id, data) {
        return this.request('post', '/api/put/{entity}/{id}', { entity, id }, data);
    }

    // POST /api/delete/{entity}/{id}
    delItem(entity, id) {
        return this.request('post', '/api/delete/{entity}/{id}', { entity, id }, { delete: true });
    }
}

// Istanza globale condivisa da tutti i moduli
const api = new OutreachAPI();
